import { useEffect } from "react";

export const useTitle = (title) => {

  useEffect(() => {
    document.title = `${title} - MWPierre Espaces Verts Montbéliard 25`;
  }, [title]);

  return null;
}